import DStateSelector from './DStateSelector.vue';
import { registerComponents, vueUse } from '../../../utils/plugins';

const components = {
  DStateSelector,
};

const Registered = {
  install(Vue) {
    registerComponents(Vue, components);
  },
};

vueUse(Registered);

export default Registered;